export { default } from './EmployeeSpotlight';
